import './scss/index.scss';
import 'owl.carousel';
import { dcFactory } from 'dc';
import FeaturedServicesComponent from './js/featured-services.component';
import SelectionOptionsComponent from "./js/selection-options.component";

dcFactory.register(FeaturedServicesComponent);
dcFactory.register(SelectionOptionsComponent);
